import React from 'react';
import { NavLink, Outlet, Link } from 'react-router-dom';
import { LayoutDashboard, UtensilsCrossed, ShoppingBag, Users, CalendarClock, LogOut, Home } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/admin', label: 'Tableau de bord', icon: LayoutDashboard, end: true, testid: 'admin-nav-dashboard' },
  { to: '/admin/dishes', label: 'Plats', icon: UtensilsCrossed, testid: 'admin-nav-dishes' },
  { to: '/admin/orders', label: 'Commandes', icon: ShoppingBag, testid: 'admin-nav-orders' },
  { to: '/admin/users', label: 'Utilisateurs', icon: Users, testid: 'admin-nav-users' },
  { to: '/admin/availability', label: 'Disponibilités', icon: CalendarClock, testid: 'admin-nav-availability' },
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#F5EFE3] flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#3E2723] text-white flex flex-col fixed h-screen" data-testid="admin-sidebar">
        <div className="p-6 border-b border-white/10">
          <Link to="/admin" className="block">
            <p className="font-heading text-xl font-bold leading-tight">Racines <span className="text-[#D4A373]">&</span> Épices</p>
            <p className="text-xs uppercase tracking-widest text-[#D4A373] mt-1">Espace Admin</p>
          </Link>
        </div>

        <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
          {navItems.map(({ to, label, icon: Icon, end, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  isActive ? 'bg-[#D4A373] text-[#3E2723]' : 'text-white/80 hover:bg-white/5 hover:text-white'
                }`
              }
            >
              <Icon size={18} />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-white/10 space-y-1">
          <Link to="/" className="flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-white/70 hover:bg-white/5 hover:text-white" data-testid="admin-back-site">
            <Home size={18} />
            <span>Retour au site</span>
          </Link>
          <button
            onClick={logout}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg text-sm text-white/70 hover:bg-white/5 hover:text-white"
            data-testid="admin-logout"
          >
            <LogOut size={18} />
            <span>Déconnexion</span>
          </button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 ml-64 p-8">
        <div className="flex justify-end mb-6">
          <div className="text-right">
            <p className="text-sm text-[#6D4C41]">Connecté en tant que</p>
            <p className="font-medium text-[#3E2723]">{user?.name}</p>
          </div>
        </div>
        <Outlet />
      </main>
    </div>
  );
};
